import React, { useContext } from 'react'
import { CarOrderingContext } from "../../../CarOrdering";
import EnvInput from "../../Misc/EnvInput";
import EnvZipCodeInput from "../../Misc/EnvZipCodeInput";
import CheckoutOverview from "../CheckoutOverview";
import TradePaymentRadio from "../TradePaymentRadio";
import Price from "../../Misc/Price";
import PaymentRadio from "../PaymentRadio";
import PaymentTerms from "../PaymentTerms";
import Newsletter from "../Newsletter";
import ErrorMessage from "../../Misc/ErrorMessage";
import LocationField from "../LocationField";

export default function StepCheckout() {
  const {
    currentStep,
    locations,
    order,
    steps,
    strings,
    zipCodes,
  } = useContext(CarOrderingContext)

  const step = steps.find(step => step.isCheckout)

  return (
    <div id='step-checkout'>
      <div className='config-form'>
        <div className='config-form__inner'>
          <h2 className='config-title'>{step.title}</h2>
          {typeof step.subtitle === 'string' && step.subtitle.length > 0 && (
            <div
              className='description'
              dangerouslySetInnerHTML={{ __html: step.subtitle }}
            />
          )}

          <div className='config-form__errors'>
            <ErrorMessage field='overall' scrollToTop />
            <ErrorMessage field='order_line_error' scrollToTop />
          </div>

          <div className='config-form__inputs'>
            <h2 className='config-form__subtitle'>
              {strings.checkout?.formTitle}
            </h2>

            <div className='config-form__input config-form__input--half'>
              <label htmlFor='first_name' className='config-form__input-label'>
                {strings.checkout.labels.firstName}
              </label>
              <EnvInput
                id='first_name'
                name='first_name'
                placeholder={strings.checkout.placeholders.firstName}
                autoComplete='given-name'
              />
            </div>

            <div className='config-form__input config-form__input--half'>
              <label htmlFor='last_name' className='config-form__input-label'>
                {strings.checkout.labels.lastName}
              </label>
              <EnvInput
                id='last_name'
                name='last_name'
                placeholder={strings.checkout.placeholders.lastName}
                autoComplete='family-name'
              />
            </div>

            <div className='config-form__input'>
              <label
                htmlFor='address'
                className='config-form__input-label'
              >
                {strings.checkout.labels.address}
              </label>
              <EnvInput
                id='address'
                name='address'
                placeholder={strings.checkout.placeholders.address}
                autoComplete='street-address'
              />
            </div>

            <div className='config-form__input config-form__input--half'>
              <EnvZipCodeInput
                label={strings.checkout.labels.zip}
                placeholder={strings.checkout.placeholders.zip}
              />
            </div>

            <div className='config-form__input config-form__input--half'>
              <label
                htmlFor='city'
                className='config-form__input-label'
              >
                {strings.checkout.labels.city}
              </label>
              <EnvInput
                id='city'
                name='city'
                placeholder={strings.checkout.placeholders.city}
                autoComplete='address-level2'
                readOnly={Object.keys(zipCodes).length !== 0}
                tabIndex={Object.keys(zipCodes).length !== 0 ? -1 : 0}
              />
            </div>

            <div className='config-form__input config-form__input--half'>
              <label htmlFor='telephone' className='config-form__input-label'>
                {strings.checkout.labels.phone}
              </label>
              <EnvInput
                id='telephone'
                name='telephone'
                placeholder={strings.checkout.placeholders.phone}
                type='tel'
                autoComplete='tel'
              />
            </div>

            <div className='config-form__input config-form__input--half'>
              <label htmlFor='email' className='config-form__input-label'>
                {strings.checkout.labels.email}
              </label>
              <EnvInput
                id='email'
                name='email'
                placeholder={strings.checkout.placeholders.email}
                type='email'
                autoComplete='email'
              />
            </div>
          </div>

          <div className='config-form__separator'/>

          {currentStep?.fields?.displayTradein && (
            <TradePaymentRadio/>
          )}

          {currentStep?.fields?.displayRestpayment && (
            <PaymentRadio
              name='rest_payment'
              title={strings.checkout.restPayment.label}
              tip={strings.checkout.restPayment.tip}
              options={[
                {
                  label: strings.checkout.restPayment.cash,
                  description: <Price price={order.price - order.security_deposit}/>,
                  value: 'cash'
                },
                {
                  label: strings.checkout.restPayment.finance,
                  description: strings.checkout.restPayment.financeDescription,
                  value: 'finance'
                }
              ]}
            />
          )}

          {currentStep?.fields?.displayInsurance && (
            <PaymentRadio
              name='insurance'
              title={strings.checkout.insurance.label}
              tip={strings.checkout.insurance.tip}
              showChildren={(value) => value === 'no'}
              options={[
                {
                  label: strings.checkout.insurance.offer,
                  description: strings.checkout.insurance.offerDescription,
                  value: 'yes'
                },
                {
                  label: strings.checkout.insurance.insurance,
                  description: strings.checkout.insurance.insuranceDescription,
                  value: 'no'
                }
              ]}
            >
              <div className='config-form__separator-transparent'/>
              <div className='config-form__inputs'>
                <label htmlFor='insurer' className='config-form__input-label'>
                  {strings.checkout.labels.insurer}
                </label>
                <EnvInput
                  id='insurer'
                  name='insurer'
                  placeholder={strings.checkout.placeholders.insurer}
                  required={false}
                />
              </div>
            </PaymentRadio>
          )}

          {currentStep?.fields?.displayServiceAgreement && (
            <PaymentRadio
              name='service_agreement'
              title={strings.checkout.serviceAgreement.label}
              tip={strings.checkout.serviceAgreement.tip}
              options={[
                {
                  label: strings.checkout.serviceAgreement.yes,
                  value: 'yes'
                },
                {
                  label: strings.checkout.serviceAgreement.no,
                  value: 'no'
                }
              ]}
            />
          )}

          {Object.keys(locations).length > 0 && (
            <LocationField
              title={strings.checkout.location.label}
              tip={strings.checkout.location.tip}
            />
          )}

          <PaymentTerms/>

          <Newsletter/>
        </div>
      </div>

      <CheckoutOverview/>
    </div>
  )
}
